import { ProjectResponseDto } from '../dto/response/project-response.dto';
import { ProjectSaveRequestDto } from '../dto/request/project-save-request.dto';
import { ProjectUpdateRequestDto } from '../dto/request/project-update-request.dto';
import { EnrichedProjectResponseDto } from '../dto/response/enriched-project-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class ProjectService extends BaseLandscapeService {
  public async fetchProjects(): Promise<EnrichedProjectResponseDto[]> {
    const response = await this.get<EnrichedProjectResponseDto[]>(
      `/project/getallprojects`
    );
    return response.data;
  }

  public async fetchProjectById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<EnrichedProjectResponseDto> {
    const response = await this.get<EnrichedProjectResponseDto>(
      `/project/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async fetchProjectsByLandscapeId(
    landscapeId: string
  ): Promise<ProjectResponseDto[]> {
    const response = await this.get<ProjectResponseDto[]>(
      `/project/getbycompactid/${landscapeId}`
    );
    return response.data;
  }

  public async fetchProjectsByLandscapeIds(
    landscapeIds: string[]
  ): Promise<ProjectResponseDto[]> {
    const response = await this.get<ProjectResponseDto[]>(
      `/project/getbycompactids`,
      {
        params: {
          compactIds: landscapeIds,
        },
      }
    );
    return response.data;
  }

  public async saveProject(
    saveRequest: ProjectSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<ProjectResponseDto> {
    const response = await this.post<ProjectResponseDto>(
      `/project`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateProject(
    updateRequest: ProjectUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<ProjectResponseDto> {
    const response = await this.put<ProjectResponseDto>(
      `/project`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteProject(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/project/${existingId}`, {
      params: {
        compactId: compactId,
      },
    });
  }
}

const projectService = new ProjectService();
export default projectService;
